/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_Recipient_PlaceholderInputs */

const en_messages_recipient_placeholder = /** @type {(inputs: Messages_Recipient_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search students, contacts, groups…`)
};

const he_messages_recipient_placeholder = /** @type {(inputs: Messages_Recipient_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`חיפוש תלמידים, אנשי קשר, קבוצות…`)
};

/**
* | output |
* | --- |
* | "Search students, contacts, groups…" |
*
* @param {Messages_Recipient_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const messages_recipient_placeholder = /** @type {((inputs?: Messages_Recipient_PlaceholderInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_Recipient_PlaceholderInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_recipient_placeholder(inputs)
	return he_messages_recipient_placeholder(inputs)
});